const APPROVED_IDENTITY_STATUSES = new Set(['approved', 'already_verified', 'freigegeben']);
const APPROVED_BUSINESS_STATUSES = new Set([
  'approved',
  'already_verified',
  'not_required',
  'nicht_erforderlich',
  'freigegeben',
]);
const PLANNED_FOUNDING_TYPES = new Set([
  'gruendung',
  'gründung',
  'in-gruendung',
  'in_gruendung',
  'gruendung_geplant',
  'gründung geplant',
]);
const OPEN_FOUNDING_BUSINESS_STATUSES = new Set([
  'pending',
  'submitted',
  'in_review',
  'additional_requested',
]);

function normalizeStatus(value) {
  return String(value || '').trim().toLowerCase();
}

// Separate from company-sensitive features: mail requires identity approval.
export function hasMailboxIdentityAccess(verification) {
  return APPROVED_IDENTITY_STATUSES.has(normalizeStatus(verification?.identity_status));
}

export function hasBusinessHubFeatureAccess({ identityStatus, businessStatus, customerType }) {
  const identity = normalizeStatus(identityStatus);
  const business = normalizeStatus(businessStatus);
  const type = normalizeStatus(customerType);

  if (!APPROVED_IDENTITY_STATUSES.has(identity)) return false;
  if (APPROVED_BUSINESS_STATUSES.has(business)) return true;

  return PLANNED_FOUNDING_TYPES.has(type) && OPEN_FOUNDING_BUSINESS_STATUSES.has(business);
}
